import avatar from '@/assets/flo/avatar.png';
import React, { useEffect, useRef } from 'react';
import './style.scss';

interface Props {
    size?: number;
    positionY: number;
}

const Avatar = ({ size = 75, positionY }: Props) => {
    const avatarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (avatarRef.current) {
            const pos = positionY - avatarRef.current.getBoundingClientRect().height;
            avatarRef.current.style.top = `${pos}px`;
        }
    }, [positionY]);

    return (
        <div className="p-1 rounded-circle avatar-flo" key="avatar" ref={avatarRef} style={{ width: `${size}px`, height: `${size}px` }}>
            <img alt="flo" className="rounded-circle" src={avatar} />
        </div>
    );
};

export default Avatar;
